<template>
  <div class="body">
    <div class="header">
      <a class="logo" href="javascript:;" @click="$router.push({path:'/'})">
        <img src="../assets/img/logo.svg" alt>
      </a>
      <a class="menu_btn" href="javascript:;">
        <img src="../assets/img/menu.png" alt>
      </a>
    </div>
    <div class="box"></div>
    <div class="inp" v-for="(item,index) in peoples" :key="index" @click="add(item,index)">
      <!-- <span v-if="showmsg" class="attendee">添加参会人信息</span>
      <span v-if="show" class="attendees">{{item.name}}</span>-->
      <!-- <input class="boder in" placeholder="添加参会人信息" disabled v-model="item.name"
        @click="add(item,index)"> -->
      <mt-field
        class="boder inn"
        placeholder="添加参会人信息"
        disabled
        v-model="item.name"
        @click="add(item,index)"
      ></mt-field>
      <span class="spanimg" @click="add(item,index)">
        <img src="../assets/img/huiyiAdd.png" class="img">
      </span>
    </div>
    <mt-popup
      v-model="popupVisible"
      position="bottom"
      popup-transition="popup-fade"
      class="popupfade"
    >
      <div class="fade">
        <div class="fadebox">
          <img src="../assets/img/huiyiTitle.png" class="fadeimg" v-if="isAndroid">
          <span class="fadeimgg" v-if="isiOS"></span>
          <span class="fademsg">参会人信息</span>
        </div>
        <div class="fadeplaceholder"></div>
        <div class="inp fadeinp">
          <input class="boder in" placeholder="姓名" v-model="name" @blur="animateWidth()">
        </div>
        <div class="inp fadeinp">
          <input
            class="boder in"
            placeholder="电话"
            type="tel"
            v-model="iphone"
            @blur="animateWidth()"
          >
        </div>
        <div class="inp fadeinp">
          <input class="boder in" placeholder="职位" v-model="job" @blur="animateWidth()">
        </div>
        <div class="inp fadeinp">
          <input
            class="boder in"
            placeholder="邮箱"
            type="email"
            v-model="email"
            @blur="animateWidth()"
          >
        </div>
        <div class="btn">
          <span class="button" @click="fadebtn">确定</span>
        </div>
      </div>
    </mt-popup>
    <div class="p"></div>
    <div class="btn">
      <span class="button" @click="next">下一步</span>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      people: '',
      peoples: [],
      show: false,
      showmsg: true,
      popupVisible: false,
      name: '',
      iphone: '',
      job: '',
      email: '',
      index: '',
      id: '',
      isAndroid: false,
      isiOS: false,
      show: false,
      enrollAttendeesReqDTO: {},
      enrollId: '',
      attendeeIds: []
    }
  },
  created () {
    this.data()
  },
  mounted () {
    this.download()
  },
  methods: {
    animateWidth () {
      setTimeout(() => {
        const scrollHeight =
          document.documentElement.scrollTop || document.body.scrollTop || 0
        window.scrollTo(0, Math.max(scrollHeight - 1, 0))
        // console.log('tag', '333')
      }, 100)
    },
    // 判断ios android
    download () {
      let ua = navigator.userAgent.toLowerCase()
      let isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1 // android终端
      let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
      if (isWeixinBrowser()) {
        // this.ShowDark = !this.ShowDark;
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          // ios
          this.isiOS = true
        } else if (/(Android)/i.test(navigator.userAgent)) {
          // android
          this.isAndroid = true
        }
      } else {
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          // ios
          this.isiOS = true
        } else if (/(Android)/i.test(navigator.userAgent)) {
          // android
          this.isAndroid = true
        }
      }
      function isWeixinBrowser () {
        return !!/micromessenger/.test(ua)
      }
    },

    add (item, index) {
      // console.log('id', item)
      if (item.hasOwnProperty('id')) {
        this.id = item.id
      }
      this.name = ''
      this.job = ''
      this.iphone = ''
      this.email = ''
      this.index = index
      if (this.peoples[this.index].id) {
        this.$axios
          .get(`/api/web/phone/attendee/${this.peoples[this.index].id}`)
          .then(res => {
            // console.log('res', res)
            this.name = res.data.name
            this.job = res.data.companyDuty
            this.iphone = res.data.phone
            this.email = res.data.emailAddress
          })
      }
      this.popupVisible = true
      // console.log('this.peoples', this.peoples)
    },
    next () {
      for (var i = 0; i < this.peoples.length; i++) {
        if (this.peoples[i].name == '') {
          this.show = false
          // console.log('1', '')
          this.MessageBox.alert('填写信息错误 / 参会人数').then(action => {})
          return
        } else {
          this.show = true
          // console.log('2', '')
        }
      }
      if (this.show) {
        this.peoples.forEach(i => {
          this.attendeeIds.push(i.id)
        })
        localStorage.setItem('msg', JSON.stringify(this.peoples))
        this.enrollId = localStorage.getItem('enrollId')
        // const apiTicketReqestDTO = JSON.parse(localStorage.getItem('apiTicketReqestDTO'))
        // apiTicketReqestDTO.enrollId = this.enrollId
        this.enrollAttendeesReqDTO = {
          attendeeIds: this.attendeeIds,
          enrollId: this.enrollId
          // apiTicketReqestDTO: apiTicketReqestDTO
        }
        this.$axios
          .putJson(
            `/api/web/phone/enroll/attendees`,
            this.enrollAttendeesReqDTO
          )
          .then(res => {
            // console.log('res', res)
            // console.log('res', res.data.haveSurvey)
            localStorage.setItem('haveSurvey', res.data.haveSurvey)
            if (res.data.haveSurvey === true) {
              this.$router.push({
                path: `/questionnaire`,
                query: {
                  contentId: this.$route.query.contentId,
                  categoryId: this.$route.query.categoryId,
                  parentId: this.$route.query.parentId
                }
              })
            } else {
              this.$router.push({
                path: `/msg`,
                query: {
                  contentId: this.$route.query.contentId,
                  categoryId: this.$route.query.categoryId,
                  parentId: this.$route.query.parentId
                }
              })
            }
          })
      }
    },
    fadebtn () {
      console.log(this.peoples)
      if (!/(^[\u4e00-\u9fa5]{2,10}$)|(^[a-zA-Z\s]{2,10}$)/.test(this.name)) {
        this.MessageBox.alert('填写信息有误 / 姓名').then(action => {})
        this.popupVisible = true
        this.showmsg = true
        this.show = false
      } else if (this.iphone == '') {
        this.MessageBox.alert('填写信息有误 / 电话').then(action => {})
        this.popupVisible = true
        this.showmsg = true
        this.show = false
      } else if (
        !/(^[\u4e00-\u9fa5]{2,10}$)|(^[a-zA-Z\s]{2,10}$)/.test(this.job)
      ) {
        this.MessageBox.alert('填写信息有误 / 职位').then(action => {})
        this.popupVisible = true
        this.showmsg = true
        this.show = false
      } else if (
        !/^[a-zA-Z0-9]+([._\\-]*[a-zA-Z0-9])*@([a-zA-Z0-9]+[-a-zA-Z0-9]*[a-zA-Z0-9]+.){1,63}[a-zA-Z0-9]+$/.test(
          this.email
        )
      ) {
        this.MessageBox.alert('填写信息有误 / 邮箱').then(action => {})
        this.popupVisible = true
        this.showmsg = true
        this.show = false
      } else {
        const Attendee = {
          name: this.name,
          companyDuty: this.job,
          phone: this.iphone,
          emailAddress: this.email
        }
        if (this.id) {
          Attendee.id = this.id
          this.id = ''
        }
        // console.log('tag', Attendee)
        this.$axios
          .postJson('/api/web/phone/attendee/add', Attendee)
          .then(res => {
            // console.log('res', res)
            this.peoples[this.index].name = this.name
            this.peoples[this.index].id = res.data.id
            this.peoples[this.index].iphone = res.data.phone
            this.peoples[this.index].email = res.data.emailAddress
            this.peoples[this.index].job = res.data.companyDuty
            // console.log('peoples', this.peoples)
          })
        this.popupVisible = false
        this.showmsg = false
        this.show = true
      }
    },
    data () {
      this.detail = JSON.parse(localStorage.getItem('detail'))
      if (this.detail.contentId.toString() !== this.$route.query.contentId) {
        // console.log('tag', 'meiyou')
        // window.location.href = `/singup?contentId=${this.$route.query.contentId}&categoryId=${this.$route.query.categoryId}&parentId=${this.$route.query.parentId}`;
        window.location.href = window.location.href.replace(
          'applicant',
          'singup'
        )
        // console.log('123', window.location.href)
      } else {
        this.people = localStorage.getItem('peoples')
        for (var i = 0; i < this.people; i++) {
          this.peoples.push({
            name: ''
          })
        }
        const fenxiangdizhi = window.location.href.replace(
          'applicant',
          'singup'
        )
        // console.log('tag', fenxiangdizhi)
        this.wxShare(
          this.detail.title,
          this.detail.description,
          this.detail.thumbApp,
          fenxiangdizhi
        )
        // console.log("tag", this.people);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/sass/global.scss";
</style>
<style lang="scss" scoped>
.fade .fadeinp {
  margin: 0 30px;
  height: 60px;
}
.fadeplaceholder {
  height: 60px;
}
.fadebox {
  position: relative;
  .fadeimg {
    position: absolute;
    width: 4px;
    top: 31px;
    left: 30px;
  }
  .fadeimgg {
    position: absolute;
    width: 4px;
    height: 15px;
    top: 33px;
    left: 30px;
    background: #31aaf1;
    border-radius: 1px;
  }
  .fademsg {
    position: absolute;
    top: 28px;
    left: 37px;
    font-size: 16px;
    font-weight: 700;
    color: #232323;
  }
}
.fade {
  height: 420px;
  width: 375px;
  background-color: #fff;
  border-radius: 12px 12px 0px 0px;
}
.img {
  width: 100%;
}
.spanimg {
  position: absolute;
  top: 35px;
  right: 15px;
  display: inline-block;
  width: 35px;
}
.attendee {
  display: inline-block;
  padding-top: 40px;
  padding-left: 15px;
  font-size: 16px;
  color: #a2a2a2;
}
.attendees {
  display: inline-block;
  padding-top: 40px;
  padding-left: 15px;
  font-size: 16px;
}
.btn {
  position: fixed;
  bottom: 24px;
  left: 105px;
  height: 60px;
  margin-top: 110px;
  .button {
    display: block;
    color: #fff;
    width: 165px;
    height: 42px;
    font-size: 16px;
    line-height: 42px;
    background-image: linear-gradient(190deg, #5fd5f9 0%, #31aaf1 100%);
    box-shadow: 0 3px 9px 0 #9cdbff;
    border-radius: 25px;
    text-align: center;
  }
}
.inp {
  position: relative;
  height: 80px;
  text-align: left;
  border-bottom: 1px solid #dcdcdc;
  margin: 0 14px;
  input {
    margin-left: 10px;
    font-size: 16px;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  }
}
.p {
  margin: 9px 20px 0;
  font-size: 12px;
}
.box {
  height: 56px;
}
.body {
  // overflow-y: scroll;
  // -webkit-overflow-scrolling: touch; //有回弹效果
  // position: fixed;
  // width: 100%;
  // height: 100%;
  // background-color: #fff;
  background: #fff;
  min-height: 100vh;
  box-sizing: border-box;
  position: relative;
  overflow: auto;
}
.header {
  height: 54px;
  background: #ffffff;
  border-bottom: 2px solid #f5f5f5;
  top: 0;
  left: 0;
  right: 0;
  position: fixed;
  z-index: 99;
  .logo {
    display: inline-block;
    // width: 133px;
    // height: 38px;
    position: absolute;
    top: 10px;
    left: 15px;
    img{
      height: 35px;
    }
  }
  .menu_btn {
    display: inline-block;
    position: absolute;
    top: 13px;
    right: 13px;
    width: 29px;
    height: 29px;
    -webkit-tap-highlight-color: transparent;
    img {
      width: 100%;
      height: 100%;
    }
  }
}

.back {
}
.signup {
  font-weight: 700;
  font-family: PingFangSC-Medium;
  font-size: 17px;
  color: #232323;
  letter-spacing: 0;
}
</style>
<style scoped>
.boder {
  width: 100%;
  height: 100%;
}
.boder >>> .mint-cell-wrapper {
  background-image: none;
  margin-top: 10px;
}
.popupfade {
  border-radius: 12px 12px 0px 0px;
}
.in >>> .mint-cell-wrapper {
  padding-left: 0;
}
.inn >>> .mint-cell-wrapper {
  margin-top: 29px;
}
.inn >>> input:disabled,
input[disabled] {
  color: #353535 important;
  opacity: 1;
  /* -webkit-text-fill-color: #353535; */
}
</style>



// WEBPACK FOOTER //
// src/components/applicant.vue